import { IPullRequestHighlight } from "@acumen/dashboard-common";

export const filterPullRequestDisplayData = (highlights: IPullRequestHighlight[]) =>
	highlights.filter((highlight) => highlight.weight > 0);
